<ng-container
  *ngIf="
    { categories: categories$ | async, filenames: filenames$ | async } as data;
    else loading
  "
>
  <form [formGroup]="updateProductForm" (ngSubmit)="submitUpdatedProduct()">
    <ng-container *ngIf="data.categories">
      <app-product-form
        #productForm
        [rootCategories]="data.categories"
        [fileNames]="data.filenames || []"
        formControlName="product"
      ></app-product-form>
    </ng-container>
    <div>
      <br />
      <button
        gaEvent="edit_product"
        mat-raised-button
        color="primary"
        [class.spinner]="submitted"
        [disabled]="isSubmitDisabled"
      >
        {{ buttonLabel }}
      </button>
    </div>
  </form>
</ng-container>

<ng-template #loading>
  <mat-spinner></mat-spinner>
</ng-template>
